import { useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { getTourForPath } from 'src/config/tours';
import { useTourAutoStart } from 'src/hooks/useTour';

/**
 * Component that auto-starts tours based on the current route.
 * Must be rendered inside TourProvider.
 */
const TourAutoStarter = () => {
  const location = useLocation();
  const { user, isImpersonating } = useAuth();

  const tourConfig = isImpersonating
    ? null
    : getTourForPath(location.pathname, user);

  useTourAutoStart(tourConfig);

  return null;
};

export default TourAutoStarter;
